import { env } from "@/lib/env";

const STAT_CARDS = [
  { label: "Active clients", value: "128" },
  { label: "Reports this month", value: "46" },
  { label: "Avg. TCI score", value: "72.4" },
  { label: "Pending reviews", value: "9" },
] as const;

const TABLE_ROWS = [
  ["Northwind Ops", "Completed", "78", "2h ago"],
  ["Cedar Logistics", "In review", "64", "5h ago"],
  ["Harbor Retail", "Completed", "81", "1d ago"],
  ["Summit Health", "Draft", "57", "1d ago"],
  ["Atlas Energy", "Completed", "73", "2d ago"],
  ["Brightline Co", "In review", "69", "3d ago"],
] as const;

/**
 * Decorative admin shell shown behind the blur for unauthenticated visitors.
 * Not interactive and not backed by live data.
 */
export function AdminLockedPreview() {
  return (
    <div className="flex h-full min-h-full w-full bg-slate-50 dark:bg-slate-950">
      <aside className="hidden w-56 shrink-0 border-r border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900 md:block">
        <p className="mb-6 text-sm font-semibold tracking-tight text-slate-900 dark:text-slate-100">
          {env.appName}
        </p>
        <nav className="space-y-1 text-sm">
          {["Dashboard", "Clients", "Reports", "Settings"].map(
            (item, index) => (
              <div
                key={item}
                className={
                  index === 0
                    ? "rounded-md bg-slate-100 px-3 py-2 font-medium text-slate-900 dark:bg-slate-800 dark:text-slate-100"
                    : "rounded-md px-3 py-2 text-slate-600 dark:text-slate-400"
                }
              >
                {item}
              </div>
            ),
          )}
        </nav>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-14 items-center justify-between border-b border-slate-200 bg-white px-4 dark:border-slate-800 dark:bg-slate-900 sm:px-6">
          <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">
            Admin dashboard
          </p>
          <div className="flex items-center gap-2">
            <div className="h-8 w-24 rounded-md bg-slate-100 dark:bg-slate-800" />
            <div className="h-8 w-8 rounded-full bg-slate-200 dark:bg-slate-700" />
          </div>
        </header>

        <div className="space-y-6 p-4 sm:p-6">
          <div>
            <p className="text-sm font-medium uppercase tracking-wider text-brand-600 dark:text-brand-400">
              Overview
            </p>
            <h1 className="mt-1 text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
              Trapped capacity insights
            </h1>
          </div>

          <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
            {STAT_CARDS.map((card) => (
              <div
                key={card.label}
                className="rounded-lg border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900"
              >
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  {card.label}
                </p>
                <p className="mt-2 text-2xl font-semibold text-slate-900 dark:text-slate-50">
                  {card.value}
                </p>
              </div>
            ))}
          </div>

          <div className="overflow-hidden rounded-lg border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900">
            <div className="border-b border-slate-200 px-4 py-3 dark:border-slate-800">
              <p className="text-sm font-medium text-slate-900 dark:text-slate-100">
                Recent assessments
              </p>
            </div>
            <table className="w-full text-left text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500 dark:bg-slate-950 dark:text-slate-400">
                <tr>
                  <th className="px-4 py-2 font-medium">Client</th>
                  <th className="px-4 py-2 font-medium">Status</th>
                  <th className="px-4 py-2 font-medium">TCI</th>
                  <th className="px-4 py-2 font-medium">Updated</th>
                </tr>
              </thead>
              <tbody>
                {TABLE_ROWS.map((row) => (
                  <tr
                    key={row[0]}
                    className="border-t border-slate-100 dark:border-slate-800"
                  >
                    {row.map((cell) => (
                      <td
                        key={`${row[0]}-${cell}`}
                        className="px-4 py-3 text-slate-700 dark:text-slate-300"
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
